import { provide, inject } from 'vue';
import ProductDetailUpsellAddToBasket from '@/shared/product/upsell/ui/ProductDetailUpsellAddToBasket.vue';
import { BasketModel } from '@/storecontext/shared/api/server-apis';
import { PurchaseOption, PurchaseOptionType } from '@/types/productServerApi';

const provideAddToBasketEndpointScope: string = 'ProvideAddToBasketEndpointScope';
const providePurchaseOptionTypeScope: string = 'ProvidePurchaseOptionTypeScope';

export type ProductDetailUpsellAddToBasket = (id: string, purchaseType: PurchaseOptionType, quantity: number) => Promise<void | BasketModel>;
export type GetProductDetailUpsellAddToBasketEndpoint = (id: string, purchaseType: PurchaseOptionType, quantity: number) => ProductDetailUpsellAddToBasket;

export interface ProductDetailUpsellAddToBasketEndpoints {
    addToBasket: ProductDetailUpsellAddToBasket,
}

export type PreferredPurchaseOptionType = (
    purchaseOptions: PurchaseOption[],
    parentProductPurchaseOptionType: PurchaseOptionType | null,
    relevantStoreId: string | null,
    basketHasClickAndCollect?: boolean,
    basketHasInstant?: boolean) => PurchaseOptionType | null;
export type GetPreferredPurchaseOptionType = (
    purchaseOptions: PurchaseOption[],
    parentProductPurchaseOptionType: PurchaseOptionType | null,
    relevantStoreId: string | null,
    basketHasClickAndCollect?: boolean,
    basketHasInstant?: boolean) => PurchaseOptionType | null;

export function provideAddToBasketEndpoints(addToBasket: ProductDetailUpsellAddToBasket): void {
    provide(provideAddToBasketEndpointScope, addToBasket);
}

export function providePurchaseOptionType(preferredPurchaseOptionType: PreferredPurchaseOptionType): void {
    provide(providePurchaseOptionTypeScope, preferredPurchaseOptionType);
}

export function useProductDetailUpsellAddToBasket() {
    const getEndpoint = inject<GetProductDetailUpsellAddToBasketEndpoint>(provideAddToBasketEndpointScope);
    if (!getEndpoint) {
        throw new Error(`No ${provideAddToBasketEndpointScope} provided`);
    }
    return getEndpoint;
}

export function useProductDetailUpsellAddToBasketPurchaseOption() {
    const getPurchaseOptionType = inject<GetPreferredPurchaseOptionType>(providePurchaseOptionTypeScope);
    if (!getPurchaseOptionType) {
        throw new Error(`No ${providePurchaseOptionTypeScope} provided`);
    }

    return getPurchaseOptionType;
}
